import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import react1 from '../assets/react1.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import mongodb from '../assets/mongodb.png';
import sass from '../assets/sass.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import resume from '../assets/Mohammad_Imran_Resume.pdf';
import refrigerator from '../assets/refrigerator.jpg';
import gymEquipment from '../assets/gymEquipment.jpg';
import dentalSolution from '../assets/dentalSolution.jpg';
import firebase from '../assets/firebase.png';
import tailwind from '../assets/tailwind.png';
import expressjs from '../assets/expressjs.png';
import wordpress from '../assets/wordpress.png';
import photoshop from '../assets/photoshop.png';
import illustrator from '../assets/illustrator.png'

export default {
  email,
  mobile,
  css,
  figma,
  react1,
  git,
  html,
  javascript,
  node,
  react,
  mongodb,
  sass,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  refrigerator,
  gymEquipment,
  dentalSolution,
  resume,
  tailwind,
  firebase,
  expressjs,
  wordpress,
  photoshop,
  illustrator
};